// functions/errors.ts
import type { AxiosError } from "axios";

export const isAxiosError = (e: unknown): e is AxiosError => {
    return !!(e as any)?.isAxiosError;
};

export const getHttpStatus = (e: unknown): number | undefined => {
    return isAxiosError(e) ? e.response?.status : (e as any)?.response?.status;
};

export const getErrorMessage = (e: unknown): string => {
    if (isAxiosError(e)) return e.message;
    if (e instanceof Error) return e.message;
    if (typeof e === "string") return e;
    return "Request failed";
};
